import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const CtaSection = dynamic(() => import('./CtaSection'));

export const defaultOptions = {
	copy: '<h2>An Example Headline</h2>',
	variant: 'Stacked' as const,
	color: '#ECFEFF',
	maxInlineSize: 35,
	centerButton: false,
} as const;

Builder.registerComponent(CtaSection, {
	name: 'CtaSection',
	inputs: [
		{
			name: 'copy',
			friendlyName: 'Text',
			type: 'richText',
			required: true,
			defaultValue: defaultOptions.copy,
		},
		{
			name: 'variant',
			friendlyName: 'Variant',
			type: 'string',
			required: true,
			enum: ['Inline', 'Stacked'],
			defaultValue: defaultOptions.variant,
		},
		{
			name: 'color',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.color,
			helperText: 'Be sure to select a color light enough for the text to have contrast',
		},
		{
			name: 'maxInlineSize',
			friendlyName: 'Max Inline Size (rem)',
			type: 'number',
			defaultValue: defaultOptions.maxInlineSize,
			showIf: function (options) {
				return options.get('variant') === 'Stacked';
			},
		},
		{
			name: 'centerButton',
			friendlyName: 'Center Button',
			type: 'boolean',
			defaultValue: defaultOptions.centerButton,
			showIf: function (options) {
				return options.get('variant') === 'Stacked';
			},
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: "What's My Claim Worth?",
					arrow: false,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
	image: getIconUrl(Icon.CTASection),
});
